import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Intromobius() {
  return (
    <section className="intro_mobius p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/mobius/introduction.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={725}
              height={596}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#214092" }}>Introduction</h2>
            <p>
              Mobius Risk Group is an independent multi-asset risk advisory
              firm, offering appropriate market guidance to manufacturers,
              patrons, and capital market participants.
            </p>
            <p>
              Identifying the status of mobile applications in today's business
              ecosystem, Mobius Risk Group boarded on a project to create
              Android and iOS apps to modernize their risk management
              procedures.
            </p>
            <p>
              The Android and iOS apps created for Mobius Risk Group work as
              all-inclusive tools to improve risk management practices.
            </p>
            <p>
              These mobile applications allow users to gain real-time market
              data, examine service trends, and make well-versed decisions.
            </p>
            <p>
              The apps provide intuitive interfaces, permitting users to manage
              their risks competently and utilize market prospects.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Intromobius;
